export interface ISliderSettings {
  tickInterval: number;
  step: number;
  min: number;
  max: number;
}
